<template>
    <h1>Mon id : <br> {{ whoAmI }} </h1>
</template>

<script>
import Vue from 'vue';
import { whoAmI } from '../modules/auth/auth.service';

export default Vue.extend({
  data() {
    return {
      whoAmI: '',
    }
  },
  mounted() {
    whoAmI().then(res => {
      this.whoAmI = res.data;
    });  
  },
})
</script>